import React, {MutableRefObject} from "react";
import Role from "../../inc/Role";
import toast, { Toaster } from 'react-hot-toast';

import { Modal, Button } from 'react-bootstrap/esm/index';
import * as AwsS3 from "../../inc/AwsS3";
import {QRCode} from "react-qrcode-logo";

export default function ModalQRCode(props) {
    let [data, setData] = React.useState(null);

    const ref = React.useRef(QRCode);
    const refsArr = React.useRef([QRCode]);

    React.useEffect(() => {
        let newList = [];
        (async function() {
            try {
                if(props.qrcodeLogo) {
                    for(let rs of props.qrcodeLogo) {
                        let list = {
                            fileBase64: await AwsS3.viewBase64Image(props.awsS3Config, rs.fileName)
                        };
                        newList.push(list);
                    }
                    setData(newList);
                }
            } catch (e) {
                toast.error(e.message);
            }
        })();
    }, []);

    const handleDownload = (fileName) => {
        ref.current.download('jpg', fileName);
    };

    const handleDownloadArr = (index, fileName) => {
        refsArr.current[index].download('jpg', fileName)
    };

    return (
        <>
            <Modal size="lg" show={true} onHide={props.handleModalClose}>
                <Modal.Header>
                    <Modal.Title>แสดง QRCode Short.io</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <span className="d-block fw-bold">Short URL</span>
                    {props.shortIOUrl}
                    <div className="row">
                        <div className="col-12 col-sm-6 text-center">
                            <QRCode
                                ref={ref}
                                value={props.shortIOUrl}
                                logoPadding={2}
                                logoWidth={50}
                                size={256}
                            />
                            <button type="button" className="btn btn-xs btn-success mt-1 py-1" onClick={e => handleDownload('ap-qrcode-default')} style={{ margin: '20px' }}>Download</button>
                        </div>
                        {
                            data ? data.map((row, index) => {
                                return (
                                    <div key={index} className="col-12 col-sm-6 text-center">
                                        <QRCode
                                            ref={(element) => refsArr.current[index] = element}
                                            value={props.shortIOUrl}
                                            logoImage={row.fileBase64}
                                            logoPadding={2}
                                            logoWidth={50}
                                            size={256}
                                            removeQrCodeBehindLogo={true}
                                        />
                                        <button type="button" className="btn btn-xs btn-success mt-1 py-1" onClick={e => handleDownloadArr(index, 'ap-qrcode-' + index)} style={{ margin: '20px' }}>Download</button>
                                    </div>
                                )
                            }) : 'กำลังโหลด..'
                        }
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={props.handleModalClose}>
                        ปิด
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
} 